import { apiClient } from './client';
import type {
  CreateFeedbackRequest,
  CreateFeedbackResponse,
  ListFeedbackParams,
  ListFeedbackResponse,
  FeedbackDetailResponse,
  FeedbackStatus,
  FeedbackTriageResult,
} from '../../types/feedback';

export const createFeedback = async (
  payload: CreateFeedbackRequest,
): Promise<CreateFeedbackResponse> => {
  const { data } = await apiClient.post<CreateFeedbackResponse>('/admin/feedback', payload);
  return data;
};

export const listFeedback = async (params: ListFeedbackParams): Promise<ListFeedbackResponse> => {
  const { data } = await apiClient.get<ListFeedbackResponse>('/admin/feedback', { params });
  return data;
};

export const getFeedbackDetail = async (id: string): Promise<FeedbackDetailResponse> => {
  const { data } = await apiClient.get<FeedbackDetailResponse>(`/admin/feedback/${id}`);
  return data;
};

export const updateFeedbackStatus = async (
  id: string,
  status: FeedbackStatus,
): Promise<{ id: string; status: FeedbackStatus }> => {
  const { data } = await apiClient.patch<{ id: string; status: FeedbackStatus }>(
    `/admin/feedback/${id}/status`,
    { status },
  );
  return data;
};

export const runTriage = async (id: string): Promise<{ triageResult: FeedbackTriageResult }> => {
  const { data } = await apiClient.post<{ triageResult: FeedbackTriageResult }>(
    `/admin/feedback/${id}/triage`,
  );
  return data;
};

export const createKnowledgeArticle = async (
  id: string,
): Promise<{ articleId: string; status: string }> => {
  const { data } = await apiClient.post<{ articleId: string; status: string }>(
    `/admin/feedback/${id}/create-knowledge-article`,
  );
  return data;
};

export const createEvalCase = async (
  id: string,
): Promise<{ evalCaseId: string; status: string }> => {
  const { data } = await apiClient.post<{ evalCaseId: string; status: string }>(
    `/admin/feedback/${id}/create-eval-case`,
  );
  return data;
};

export const createGithubIssue = async (
  id: string,
): Promise<{ issueUrl: string; existing?: boolean }> => {
  const { data } = await apiClient.post<{ issueUrl: string; existing?: boolean }>(
    `/admin/feedback/${id}/create-github-issue`,
  );
  return data;
};
